import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { createFormData } from '../utils/eventDataTransform'

import { API_BASE_URL } from '../config/api'

export const useEventSubmission = (isEditMode, eventId) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [createdEvent, setCreatedEvent] = useState(null)

  const submitEvent = async (event, mediaFiles = [], skipDuplicateCheck = false) => {
    try {
      setLoading(true)
      setError('')

      const formData = createFormData(event, mediaFiles)

      let url = isEditMode
        ? `${API_BASE_URL}/api/events/${eventId}`
        : `${API_BASE_URL}/api/events`

      // Add skipDuplicateCheck query param if requested
      if (skipDuplicateCheck && !isEditMode) {
        url += '?skipDuplicateCheck=true'
      }

      const method = isEditMode ? 'put' : 'post'
      const response = await axios[method](url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      })

      setCreatedEvent(response.data.event || response.data)
      setSuccess(isEditMode ? 'Event updated successfully!' : 'Event created successfully!')

      const createdEventId = response.data.event?._id || response.data._id
      setTimeout(() => {
        navigate(isEditMode ? `/event/${eventId}` : `/event/${createdEventId}`)
      }, 2000)

    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('Error submitting event:', err)
      if (process.env.NODE_ENV === 'development') console.error('Error response:', err.response?.data)
      if (process.env.NODE_ENV === 'development') console.error('Error status:', err.response?.status)
      if (process.env.NODE_ENV === 'development') console.error('Validation errors:', JSON.stringify(err.response?.data?.errors, null, 2))
      if (process.env.NODE_ENV === 'development') console.error('Validation details:', JSON.stringify(err.response?.data?.details, null, 2))

      // Handle 409 duplicate detection
      if (err.response?.status === 409 && err.response?.data?.duplicates) {
        const duplicateData = err.response.data
        setError({
          type: 'duplicate',
          message: duplicateData.message || 'You may have already added this event to your collection',
          duplicates: duplicateData.duplicates,
          suggestion: duplicateData.suggestion,
          canProceed: duplicateData.canProceed
        })
      } else {
        // Show detailed error message including validation errors
        let errorMsg = err.response?.data?.message || err.message || 'Failed to save event'

        // Add validation error details if available
        if (err.response?.data?.errors && Array.isArray(err.response.data.errors)) {
          const errorDetails = err.response.data.errors.join(', ')
          errorMsg += `: ${errorDetails}`
        }

        setError(errorMsg)
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    error,
    success,
    createdEvent,
    submitEvent
  }
}